module.exports = __webpack_public_path__ + "img/app0.b7d65177.png";